import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
import {Message} from 'element-ui'
import {getToken} from '@/utils/auth' // 验权
import Layout from '@/views/layout/Layout'
const whiteList = ['/login', '/privacy','/h5/winTheCustomer','/h5/eventRegistration','/h5/eventRegistration/close','/h5/eventRegistration/success'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      next({
        path: '/'
      })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if(store.getters.permission_routes.length === 0){//判断当前用户是否拉取完信息
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
            // console.log('拉取用户信息===>', res);
            let userInfo = res.data;
            store.dispatch('generateRoutes', userInfo).then(menu => { // 生成可访问的路由表
              console.log('可访问的的路由表===>', menu)
              router.addRoutes(menu) // 动态添加可访问路由表
            })
            next()
          }).catch((err) => {
            store.dispatch('FedLogOut').then(() => {
              Message.error(err || 'Verification failed, please login again')
              next({ path: '/' })
            })
          })
      }else{
        if (from.name !== 'detail' && store.getters.page !== 1) {
          store.commit('SET_PAGE', 1)
        }
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) { //在免登录白名单，直接进入
      next()
    } else {
      next('/login'); // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js